import {
  APIListValuesRequest,
  APIListValuesResponse,
  APIPaginatedRequest,
  getFetcher,
  postFetcher,
} from "shared/api/api";
import client from "shared/api/axios";
import { createURL } from "shared/api/utils";

const INSTANCE_MANAGEMENT_BASE_ROUTE = "instanceManagement";

const TENANTS_BASE_ROUTE = "tenants";

export interface InstanceManagementTenant {
  name: string;
  createdAt: string;
  createdBy: string;
  domainCreationFinished: boolean;
  s3BucketCreated: boolean;
  certificateCreationFinished: boolean;
  clickhouseRoleCreated: boolean;
  clickhouseUserCreated: boolean;
  metabaseResourcesCreated: boolean;
  oktaResourcesCreated: boolean;
  kmsKeyCreated: boolean;
  awsRoleCreated: boolean;
  isActive: boolean;
  oktaAppLink: string | null;
  isTesting: boolean;
  deletionScheduledAt: string | null;
  deletionScheduledBy: string | null;
  deletionStartedAt: string | null;
  awsInfraDeletedAt: string | null;
  s3DataDeletionScheduledAt: string | null;
  s3BucketDeletedAt: string | null;
  kubernetesDeletedAt: string | null;
  externalServicesDeletedAt: string | null;
  clickhouseDataDeletedAt: string | null;
  postgresDataDeletedAt: string | null;
}

export interface InstanceManagementTenantRequest {
  name: string;
  admins: string[];
  superAdmins: string[];
  enableAllAttributes: boolean;
  isTesting?: boolean;
}

export interface ListInstanceManagementTenantsRequest extends APIPaginatedRequest {}

const listInstanceManagementTenantsValuesRequestURI = ({
  fieldName,
  ...params
}: APIListValuesRequest): string =>
  client.getUri({
    method: "get",
    url: createURL([
      INSTANCE_MANAGEMENT_BASE_ROUTE,
      TENANTS_BASE_ROUTE,
      "values",
      fieldName,
    ]),
    params,
  });

export const listInstanceManagementTenantsValues = (
  args: APIListValuesRequest
) =>
  getFetcher<APIListValuesResponse>(
    listInstanceManagementTenantsValuesRequestURI(args)
  );

export const listInstanceManagementTenantsRequestURI = (
  params: ListInstanceManagementTenantsRequest
): string =>
  client.getUri({
    method: "GET",
    url: createURL([INSTANCE_MANAGEMENT_BASE_ROUTE, TENANTS_BASE_ROUTE]),
    params,
  });

const createInstanceManagementRequestURI = (): string =>
  client.getUri({
    method: "GET",
    url: createURL([INSTANCE_MANAGEMENT_BASE_ROUTE, TENANTS_BASE_ROUTE]),
  });

export const newTenant = (data: InstanceManagementTenantRequest) =>
  postFetcher<InstanceManagementTenant>(
    createInstanceManagementRequestURI(),
    data
  );

const tenantRequestURI = (name: string): string =>
  client.getUri({
    method: "GET",
    url: createURL([INSTANCE_MANAGEMENT_BASE_ROUTE, TENANTS_BASE_ROUTE, name]),
  });

const cancelTenantDeletionRequestURI = (name: string): string =>
  client.getUri({
    method: "GET",
    url: createURL([
      INSTANCE_MANAGEMENT_BASE_ROUTE,
      TENANTS_BASE_ROUTE,
      name,
      "cancelDeletion",
    ]),
  });

export const deleteTenant = (name: string) =>
  client.delete(tenantRequestURI(name));

export const cancelTenantDeletion = (name: string) =>
  client.post(cancelTenantDeletionRequestURI(name));
